import React from "react";
import { Snackbar, Alert, AlertColor } from "@mui/material";
import { brand, error, success, warning } from "../theme/themePrimitives";

export interface ToastProps {
  open: boolean;
  message: string;
  duration?: number | null;
  type?: AlertColor;
  onClose: () => void;
}

const Toast: React.FC<ToastProps> = ({
  open,
  message,
  duration = 2000,
  type = "info",
  onClose,
}) => {
  const getCustomColor = (type: AlertColor) => {
    switch (type) {
      case "success":
        return success[600];
      case "error":
        return error[600];
      case "warning":
        return warning[600];
      case "info":
        return brand[600];
      default:
        return undefined;
    }
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={duration ?? undefined}
      onClose={(_, reason) => {
        if (reason !== "clickaway") {
          onClose();
        }
      }}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
    >
      <Alert
        severity={type}
        variant="filled"
        onClose={duration === null ? onClose : undefined}
        sx={{
          backgroundColor: getCustomColor(type),
          borderColor: getCustomColor(type),
          color: "#fff",
          "& .MuiAlert-icon": {
            color: "#fff",
          },
          "& .MuiAlert-action": { color: "#fff" },
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default Toast;
